import React from 'react'
import { RemoteStringsProvider, useRemoteStrings } from '@acorns/web-utils'
import CenteredSpinner from 'components/CenteredSpinner'

function RemoteStringsRenderer({ children }) {
  const { isLoadingRemoteStrings } = useRemoteStrings()

  if (isLoadingRemoteStrings) {
    return <CenteredSpinner />
  }

  return children
}

export function AcornsHelloRemoteStringsProvider({ children }) {
  return (
    <RemoteStringsProvider>
      <RemoteStringsRenderer>{children}</RemoteStringsRenderer>
    </RemoteStringsProvider>
  )
}
